import { render } from "./UsersTable.vue?vue&type=template&id=6b2d0b5b&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"

import "./UsersTable.vue?vue&type=style&index=0&id=6b2d0b5b&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2d0b5b"]])

export default __exports__